/* eslint-disable */
import React, { useState } from "react";
import {
  ShoppingCart,
  User,
  CreditCard,
  CheckCircle,
  Package,
  Sparkles,
} from "lucide-react";
import StepIndicator from "./stepIndicator";
import { useTranslation } from "react-i18next";

const FormPreview = ({ data, store }) => {
  const { t } = useTranslation();

  // Définir les étapes avec leurs identifiants
  const allSteps = {
    info: {
      id: "info",
      title: t("formPreview.steps.personalInfo.title"),
      icon: User,
      fields: [
        {
          name: "phone",
          label: t("formPreview.steps.personalInfo.fields.phone.label"),
          required: true,
          visible: true,
          placeholder:
            data.digitalPhoneNumberPlaceHolder ||
            t("formPreview.steps.personalInfo.fields.phone.placeholder"),
        },
        {
          name: "name",
          label: t("formPreview.steps.personalInfo.fields.name.label"),
          required: data.ditalNameRequired,
          placeholder:
            data.digitalNamePlaceholder ||
            t("formPreview.steps.personalInfo.fields.name.placeholder"),
          visible: data.digitalNameField,
        },
        {
          name: "email",
          label: t("formPreview.steps.personalInfo.fields.email.label"),
          required: data.digitalEmailRequired == "required",
          visible: data.digitalEmailField,
          placeholder: data.digitalEmailPlaceholder || "example@email.dz",
        },
      ],
    },
    offer: {
      id: "offer",
      title: t("formPreview.steps.confirmOffer.title"),
      icon: CheckCircle,
      fields: [
        {
          name: "offer",
          label: t("formPreview.steps.confirmOffer.fields.offer.label"),
          required: true,
          placeholder: t(
            "formPreview.steps.confirmOffer.fields.offer.placeholder"
          ),
          visible: true,
        },
        {
          visible: true,
          name: "note",
          label: t("formPreview.steps.confirmOffer.fields.note.label"),
          required: data.digitalNoteRequired,
          placeholder:
            data.digitalNotePlaceholder ||
            t("formPreview.steps.confirmOffer.fields.note.placeholder"),
        },
      ],
    },
    payment: {
      id: "payment",
      title: t("formPreview.steps.paymentMethod.title"),
      icon: CreditCard,
      fields: [
        {
          name: "payment",
          label: t("formPreview.steps.paymentMethod.fields.payment.label"),
          required: true,
          placeholder: t(
            "formPreview.steps.paymentMethod.fields.payment.placeholder"
          ),
        },
        {
          name: "proof",
          label: t("formPreview.steps.paymentMethod.fields.proof.label"),
          required: false,
          placeholder: t(
            "formPreview.steps.paymentMethod.fields.proof.placeholder"
          ),
        },
      ],
    },
  };

  const defaultOrder = ["info", "offer", "payment"];
  const stepsOrder = data?.formStepsOrder || defaultOrder;

  const steps = stepsOrder.map((stepKey, index) => ({
    ...allSteps[stepKey],
    displayId: index + 1,
  }));

  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("baridimob");
  const paymentMethods = [
    {
      id: "baridimob",
      name: "BaridiMob",
      Firebaselabel: "slickpay",
      photo:
        "https://play-lh.googleusercontent.com/RNixvQLeIChh3f0pfYQ2asBCMbjTw0tCBHLFObcnQ2DMftqPM9D5HatPW0MqqFR8vfY",
    },
    {
      id: "cib",
      name: "CIB Bank",
      Firebaselabel: "slickpay",
      photo:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxNjrATM27CwtAVk1AxGAaeYvs368CaItQGw&s",
    },
    // {
    //   id: "binance",
    //   name: "Binance",
    //   Firebaselabel: "binance",
    //   photo:
    //     "https://public.bnbstatic.com/20190405/eb2349c3-b2f8-4a93-a286-8f86a62ea9d8.png",
    // },
    {
      id: "ccp",
      name: "ccp",
      Firebaselabel: "ccp",
      photo:
        "https://play-lh.googleusercontent.com/hD-Vr6VMUPW9q_7ueTBHCuDB0GyKw43IcxxX4ctKWgUUQ2bNTjrsIudgqeC8WtjfKes=w526-h296-rw",
    },
    {
      id: "Visa/MasterCard",
      name: "Visa/MasterCard",
      Firebaselabel: "stripe",
      photo: "/aze.png",
    },
    {
      id: "paypal",
      name: "PayPal",
      Firebaselabel: "paypal",
      photo:
        "https://upload.wikimedia.org/wikipedia/commons/a/a4/Paypal_2014_logo.png",
    },
    {
      id: "dukascopy",
      name: "Dukascopy",
      Firebaselabel: "Dukascopy",
      photo: "https://admin.foorweb.store/Dukascopy.png",
    },
    {
      id: "wise",
      name: "wise",
      Firebaselabel: "wise",
      photo: "https://admin.foorweb.store/wise.png",
    },
    {
      id: "redotpay",
      name: "redotpay",
      Firebaselabel: "redotpay",
      photo: "https://www.redotpay.com/img/favicon.png",
    },
  ];
  const enabledPaymentMethods =
    Array.isArray(paymentMethods) && store?.paymentMethods
      ? paymentMethods.filter(
          (method) => store.paymentMethods[method?.Firebaselabel]?.enabled
        )
      : [];
  const isOfferFirst = stepsOrder[0] == "offer";

  return (
    <div className="md:col-span-1">
      <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] sticky top-6">
        <div className="flex items-center mb-4">
          <ShoppingCart size={20} className="text-[#9e68ba] ml-2" />
          <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-300">
            {t("formPreview.title")}
          </h3>
        </div>

        <div className="flex items-center gap-1 mb-3 md:gap-2 md:mb-4">
          <div
            className="p-1 rounded-full md:p-2"
            style={{ backgroundColor: `${store.color1}20` }}
          >
            <ShoppingCart
              className="w-4 h-4 md:w-5 md:h-5"
              style={{ color: store.color1 }}
            />
          </div>
          <h5 className="text-sm font-semibold text-gray-800 dark:text-gray-300 md:text-xl">
            {data.digitalHeaderForm || t("formPreview.headerMessage.default")}
          </h5>
          <div className="flex gap-0.5 animate-pulse">
            <Sparkles className="w-2.5 h-2.5 text-yellow-500 md:w-3 md:h-3" />
            <Sparkles className="w-2 h-2 text-yellow-400 md:w-2.5 md:h-2.5" />
          </div>
        </div>

        <div className="space-y-4">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isFirstStep = index === 0;
            const isLastStep = index === steps.length - 1;
            return (
              <div key={step.id} className="space-y-2">
                <StepIndicator
                  store={store}
                  currentStep={step.displayId}
                  isOfferFirst={isOfferFirst}
                />

                <div
                  className="max-w-md mx-auto rounded-xl border dark:!border-[#3c3a3d] p-4 dark:!bg-[#141414]"
                  style={{
                    border: `1px solid ${data.color1 || "#9b59bf"}`,
                  }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div
                      className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                      style={{ backgroundColor: data.color1 || "#9b59bf" }}
                    >
                      {step.displayId}
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                      <h4 className="text-sm font-medium text-gray-800 dark:text-gray-300">
                        {step.title}
                      </h4>
                    </div>
                  </div>

                  <div className="space-y-2">
                    {step.fields
                      .filter((field) => field.visible !== false)
                      .map((field, fieldIndex) => (
                        <div key={fieldIndex} className="space-y-1">
                          <label className="text-xs text-gray-600 dark:text-gray-400 flex items-center gap-1">
                            {t(field.label)}{" "}
                            {field.required && (
                              <span>
                                {t("formPreview.steps.field.required")}
                              </span>
                            )}
                          </label>
                          {field.name != "payment" && (
                            <div
                              className="w-full px-3 py-2 bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg text-xs"
                              style={{ minHeight: "32px" }}
                            >
                              <span className="text-gray-400 dark:text-gray-500">
                                {field.placeholder}
                              </span>
                            </div>
                          )}
                          {field.name === "payment" && (
                            <>
                              {enabledPaymentMethods.length > 0 ? (
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                                  {enabledPaymentMethods.map((method) => {
                                    const isSelected =
                                      selectedPaymentMethod === method.id;
                                    return (
                                      <div
                                        key={method.id}
                                        className="relative cursor-pointer transition-transform duration-200 hover:scale-105"
                                        style={
                                          isSelected
                                            ? {
                                                boxShadow: `0 0 0 2px ${store.color1}`,
                                              }
                                            : {}
                                        }
                                        onClick={() =>
                                          setSelectedPaymentMethod(method.id)
                                        }
                                      >
                                        <div
                                          className="flex flex-col items-center justify-center p-2 rounded-lg border dark:!border-[#3c3a3d] min-h-[80px] hover:shadow dark:bg-[#181919]"
                                          style={{
                                            backgroundColor: isSelected
                                              ? `${store.color1}15`
                                              : `${store.color1}05`,
                                            borderColor: isSelected
                                              ? store.color1
                                              : `${store.color1}30`,
                                          }}
                                        >
                                          <div className="w-10 h-10 mb-1 flex items-center justify-center">
                                            <img
                                              src={method.photo}
                                              alt={method.name}
                                              className="max-w-full max-h-full object-contain"
                                            />
                                          </div>
                                          <span
                                            className="text-xs font-medium text-center"
                                            style={{
                                              color: isSelected
                                                ? store.color1
                                                : "#6B7280",
                                            }}
                                          >
                                            {method.name}
                                          </span>
                                          {isSelected && (
                                            <div
                                              className="absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center"
                                              style={{
                                                backgroundColor: store.color1,
                                              }}
                                            >
                                              <span className="text-white text-xs font-bold">
                                                ✓
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                                  {t(
                                    "formPreview.paymentMethods.noneAvailable"
                                  )}
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                  </div>

                  {/* Affichage de la politique de confidentialité pour l'étape "info" */}
                  {step.id === "info" && (
                    <div className="mt-4 space-y-3">
                      {data.privacyPolicyField && (
                        <div className="flex items-start gap-2 text-xs">
                          <input
                            type="checkbox"
                            className="mt-1 rounded border-gray-300 dark:bg-[#181919] dark:!border-[#3c3a3d]"
                            style={{
                              accentColor: data.color1 || "#9b59bf",
                            }}
                            disabled
                          />
                          <label className="text-gray-600 dark:text-gray-400 leading-relaxed">
                            {data.privacyPolicyPlaceholder ||
                              t("formPreview.privacyPolicy.label")}
                            {data.privacyPolicyRequired && (
                              <span>
                                {t("formPreview.privacyPolicy.required")}
                              </span>
                            )}
                          </label>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Affichage du bouton de soumission pour la dernière étape */}
                  {isLastStep && (
                    <div className="mt-4 space-y-3">
                      <div className="pt-2 border-t border-gray-100 dark:!border-[#3c3a3d]">
                        <button
                          className="w-full py-2 px-4 text-white rounded-lg text-sm font-medium"
                          style={{ backgroundColor: data.color1 || "#9b59bf" }}
                          disabled
                        >
                          {data.digitalNameButton ||
                            t("formPreview.submitButton.default")}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FormPreview;
